import script from "./AppMenuUserActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenuUserActions.vue?vue&type=script&setup=true&lang=js"

import "./AppMenuUserActions.vue?vue&type=style&index=0&id=55b339eb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b339eb"]])

export default __exports__